var _g, _g2, _path, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_4978_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 16C26.2095 16 28.0003 17.7908 28.0003 20V21.3333H29.3337V28C29.3337 28.7364 28.7367 29.3333 28.0003 29.3333H20.0003C19.2639 29.3333 18.667 28.7364 18.667 28V21.3333H20.0003V20C20.0003 17.7908 21.7911 16 24.0003 16ZM24.0003 18.6667C23.3166 18.6667 22.667 19.2667 22.667 20V21.3333H25.3337V20C25.3337 19.2636 24.7367 18.6667 24.0003 18.6667Z",
    fill: "url(#paint0_linear_4978_693)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_n_4978_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 2.6665C24.7367 2.6665 25.3337 3.26346 25.3337 3.99984L25.3353 13.4669C24.9039 13.3792 24.4575 13.3332 24.0003 13.3332C20.7751 13.3332 18.0849 15.6234 17.4671 18.6662L16.0003 18.6665V29.3332H8.00033C7.26395 29.3332 6.66699 28.7362 6.66699 27.9998V3.99984C6.66699 3.26346 7.26395 2.6665 8.00033 2.6665H24.0003Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4978_693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 20,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 2.6665C24.7367 2.6665 25.3337 3.26346 25.3337 3.99984L25.3353 13.4669C24.9039 13.3792 24.4575 13.3332 24.0003 13.3332C20.7751 13.3332 18.0849 15.6234 17.4671 18.6662L16.0003 18.6665V29.3332H8.00033C7.26395 29.3332 6.66699 28.7362 6.66699 27.9998V3.99984C6.66699 3.26346 7.26395 2.6665 8.00033 2.6665H24.0003Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4978_693)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_fn_4978_693)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.71664,
    cy: 29.4561,
    rx: 19.4888,
    ry: 31.3541,
    transform: "rotate(-52.9865 9.71664 29.4561)",
    fill: "url(#paint1_linear_4978_693)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_4978_693",
    x: 18.667,
    y: 16,
    width: 10.667,
    height: 13.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2.6666667461395264 2.6666667461395264",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1050
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.1)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4978_693"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_n_4978_693",
    x: 6.66699,
    y: 2.6665,
    width: 18.668,
    height: 26.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4978_693"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_fn_4978_693",
    x: -30.4385,
    y: -7.50781,
    width: 80.3105,
    height: 73.9277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4978_693"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4978_693",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4978_693"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4978_693"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4978_693",
    x1: 24.0003,
    y1: 16,
    x2: 24.0003,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC1503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4978_693",
    x1: 30.9784,
    y1: 42.8032,
    x2: 11.3963,
    y2: 32.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon8);
export default __webpack_public_path__ + "static/media/caseIcon8.c7427b1e190737ff8852fc2e71aca43e.svg";
export { ForwardRef as ReactComponent };